export function createExternalRoute(id) {
    return {
        id: Symbol(id),
    };
}
